import { capitalizeFirstLetter } from 'utils/capitalize-first-letter';

const FIELD_NAMES = {
  end_to_end_id: 'End-to-end ID',
  e2e_test_case: 'End-to-end sandbox test case',
  amount: 'Amount',
  virtual_account_number: 'Account',
  business_unit: 'Business Unit',
  name: 'Full Name',
  country_code: 'Country',
  address_lines: 'Address',
  city: 'City',
  postcode: 'Postal code',
  birthdate: 'Date of birth',
  iban: 'IBAN',
  id_issuing_date: 'ID issuing date',
  id_expiry_date: 'ID expiry date',
  state: 'State',
  email: 'Email',
  type: 'Type',
  website: 'URL'
};

const RECEIVER_FIELD_NAMES = {
  account: 'Account',
  account_number: 'Account number',
  address_lines: 'Address',
  bank_bic: 'Bank BIC',
  bank_name: 'Bank name',
  bank_clearing_system_code: 'Clearing system code',
  bank_clearing_system_id: 'Clearing system ID',
  birthdate: 'Date of birth',
  city: 'City',
  country_code: 'Country',
  country_of_birth_code: 'Country of birth',
  country_of_residence_code: 'Country of residence',
  created_by: 'Created by',
  creditor_type: 'Type',
  currency: 'Currency',
  email: 'Email',
  full_name: 'Full name',
  id_expiry_date: 'ID expiry date',
  id_issuing_country_code: 'ID issuing country',
  id_issuing_date: 'ID issuing date',
  id_number: 'ID number',
  id_type: 'ID type',
  name: 'Full name',
  iban: 'IBAN',
  mobile_number: 'Phone',
  postcode: 'Postal code',
  street_name: 'Street name',
  state: 'State',
  type: 'Type',
  proxy_type: 'Proxy type',
  proxy_identification: 'Proxy identification'
};

export const fieldToDisplayableName = (
  keyName: string,
  fieldNames = 'FIELD_NAMES'
): string => {
  const keyNameNoPrefix = removePrefix(keyName);
  const name =
    fieldNames === 'FIELD_NAMES'
      ? FIELD_NAMES[keyNameNoPrefix]
      : RECEIVER_FIELD_NAMES[keyNameNoPrefix];
  if (name) return name;
  console.warn('Key not found in fieldNames', keyNameNoPrefix, fieldNames);

  return convertFieldToHumanReadable(keyNameNoPrefix);
};

export const convertFieldToHumanReadable = (text: string): string => {
  // Replace underscores with spaces
  const firstPass = text.replaceAll('_', ' ');
  // Replace the word "id" only when it is a complete word, not part of another word
  // example: account id -> account ID
  // example: riddle -> riddle
  const secondPass = firstPass.replace(/\b(id)\b/g, 'ID');
  return capitalizeFirstLetter(secondPass);
};

const removePrefix = (keyName: string): string => {
  const [prefix, postfix] = keyName.split('.', 2);
  return postfix ?? prefix;
};
